var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ModalMantenedor",
    { attrs: { show: _vm.show } },
    [
      _c(
        "CabeceraModalCrear",
        { attrs: { titulo: "Crear Alerta" }, on: { cerrar: _vm.handleCerrar } },
        [
          _c("NavegacionModalCrud", {
            attrs: { pasos: _vm.pasos, "estado-id": _vm.estadoId },
            on: { guardar: _vm.handleGuardar },
            model: {
              value: _vm.pasoActivoIndex,
              callback: function($$v) {
                _vm.pasoActivoIndex = $$v
              },
              expression: "pasoActivoIndex"
            }
          })
        ],
        1
      ),
      _c(
        "v-stepper",
        {
          model: {
            value: _vm.pasoActivoIndex,
            callback: function($$v) {
              _vm.pasoActivoIndex = $$v
            },
            expression: "pasoActivoIndex"
          }
        },
        [
          _c("CrudStepperHeader", {
            attrs: {
              pasos: _vm.pasos,
              "paso-activo-index": _vm.pasoActivoIndex
            }
          }),
          _c(
            "CrudStepperItems",
            [
              _c(
                "CrudStepperContent",
                { attrs: { paso: _vm.pasos.configurarAlerta } },
                [
                  _c("ConfigurarAlertaForm", {
                    attrs: { lstAlertasBase: _vm.lstAlertasBase },
                    on: {
                      change: _vm.handleFormChange,
                      changeTipoBase: _vm.handleTipoBaseChange,
                      changeParametroGeneral: _vm.handleParametroGeneral,
                      changeCamposDinamicos: _vm.handleCamposDinamicosChange,
                      changeValidaCampos: _vm.handleValidaCamposChange,
                      changeUsoNoAutorizado: _vm.handleUsoNoAutorizadoChange,
                      changeDatosZonas: _vm.handleDatosZonas,
                      planesChange: _vm.handlePlanesChange,
                      changeValidaCamposZonas: _vm.handleValidaCamposZonas,
                      camposZonaNoAutorizadaEmpty:
                        _vm.handleCamposZonaNoAutorizadaEmpty,
                      camposZonaEmpty: _vm.handleCamposZonaEmpty,
                      camposDetencionNoAutorizadaEmpty:
                        _vm.handlecamposDetencionNoAutorizadaEmpty,
                      showAsociarVehiculos: _vm.handleShowAsociarVehiculos
                    }
                  })
                ],
                1
              ),
              _c(
                "CrudStepperContent",
                { attrs: { paso: _vm.pasos.asociarVehiculos } },
                [
                  _vm.showAsociarVehiculos
                    ? _c(
                        "v-flex",
                        [
                          _c("AsociarFlotaEtiquetaVehiculo", {
                            attrs: { "col-def-vehiculo": _vm.vehiculoColDefs },
                            on: { change: _vm.handleAsociacionesChange }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  !_vm.showAsociarVehiculos
                    ? _c(
                        "v-flex",
                        [
                          _c("AsociarFlotaEtiquetaVehiculoXMantenimiento", {
                            on: { change: _vm.handleAsociacionesChangeM }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "CrudStepperContent",
                { attrs: { paso: _vm.pasos.configurarNotificaciones } },
                [
                  _c("ConfigurarNotificacionForm", {
                    on: {
                      change: _vm.handleFormNotificarChange,
                      distribucionSelect: _vm.handleDistribucionSelect,
                      calendarioSelect: _vm.handleCalendarioSelect,
                      tipoNotificacionSeleccionado: _vm.handledTipoNotificacion
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("Confirmation", {
        attrs: {
          show: _vm.dialogConfirmacionGuardar,
          titulo: _vm.$t("mensajes.crud.crear.titulo", { entidad: "Alerta" }),
          mensaje: _vm.mensajeConfirmacion,
          textoBtnSi: _vm.$t("mensajes.crud.crear.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.crud.crear.btnCancelar")
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.handleConfirmacionGuardar($event)
          }
        }
      }),
      _c("MensajeValidacion", {
        attrs: {
          showDialog: _vm.showValidacion,
          titulo: _vm.tituloValidacion,
          mensaje: _vm.mensajeValidacion,
          items: _vm.itemsNoValidos
        },
        on: {
          modalConfirmationEmit: function($event) {
            _vm.showValidacion = false
          }
        }
      }),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "380" },
          model: {
            value: _vm.showValidacionLineal,
            callback: function($$v) {
              _vm.showValidacionLineal = $$v
            },
            expression: "showValidacionLineal"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary" } },
                [
                  _c(
                    "v-toolbar-title",
                    {
                      staticStyle: {
                        "font-size": "17px",
                        "margin-left": "10px !important"
                      }
                    },
                    [_vm._v(_vm._s(_vm.tituloValidacion))]
                  )
                ],
                1
              ),
              _c("v-divider"),
              _c("v-card-text", [
                _c("span", [_vm._v("Debe ingresar:")]),
                _c("br"),
                _c("br"),
                _c(
                  "ul",
                  _vm._l(_vm.camposZonaEmpty, function(ce) {
                    return _c("li", { key: ce }, [_vm._v(_vm._s(ce))])
                  }),
                  0
                )
              ]),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { small: "", color: "primary" },
                      on: {
                        click: function($event) {
                          _vm.showValidacionLineal = false
                        }
                      }
                    },
                    [_vm._v("Aceptar")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }